import React from 'react';
import './ToolCard.scss';
import Arrow from '../../../Icons/Arrow';
import { COLORS } from '../../../../../constants/colors';
import { truncate } from '../../../../../util/truncate';

/**
 * Renders content for a tool type
 * @param {array} tags - tags associated with card/post
 * @param {string} title - the card title/quote
 * @param {string} link - the link for the card
 * @param {boolean} isFeatured
 * @param {string} backgroundColor
 * @returns {JSX.Element}
 * @constructor
 */
const ToolCard = ({ industry, title, excerpt, link, isFeatured, backgroundColor }) => (
  <div className={`c-tool-card ${isFeatured ? 'is-featured' : ''}`}>
    <div className="c-tool-card__industry eyebrow-2">
      <span>{industry}</span>
    </div>
    <div className="c-tool-card__title h3-roobert">
      <h3>{title}</h3>
    </div>
    <div
      className="c-tool-card__excerpt body-2 color-black"
      dangerouslySetInnerHTML={{ __html: truncate(excerpt) }}
    ></div>
    <div className="c-tool-card__cta eyebrow-1 color-black">
      <a href={link}>
        <span>Learn More</span>
        <Arrow
          color={
            isFeatured && backgroundColor === 'green'
              ? COLORS.white
              : isFeatured && (backgroundColor === 'orange' || backgroundColor === 'white')
              ? COLORS.black
              : COLORS.blue
          }
        />
      </a>
    </div>
  </div>
);

export default ToolCard;
